module.exports = __webpack_public_path__ + "img/anquan1-2.123b275c.jpg";